import { memo, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import { resetValidationInfo, useImportCSVData } from 'app/store/importCSV'
import { importSubscribersThunk } from 'app/store/importCSV/importCSVExtraReducers'
import MessageAlert from 'app/components/MessageAlert'
import { checkSubscribersImport } from 'app/store/importCSV/helpers'
import { SECONDARY } from 'app/constants/button'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import { useState } from 'react'

const ImportButton = () => {
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()
  const [isLoading, setIsLoading] = useState(false)

  const {
    data: { rows },
  } = useImportCSVData()

  const showSnackbar = (msg) => {
    const secondsInmillisec = 10000
    dispatch(
      MessageAlert.showError({ message: msg, duration: secondsInmillisec }),
    )
  }

  const subscribersCount = useMemo(() => {
    const validSubscribers = rows.filter(
      ({ errors }) => !errors?.isRequiredFields,
    )
    return validSubscribers.length
  }, [rows])

  const disabledBtn = !subscribersCount

  const handleImport = async () => {
    setIsLoading(true)
    const handleShowSnackbar = () => {
      showSnackbar(formatMessage({ id: 'wrong.msg' }))
      setIsLoading(false)
    }
    if (!disabledBtn) {
      const isInProcess = await checkSubscribersImport({ handleShowSnackbar })
      if (isInProcess) {
        showSnackbar(
          formatMessage({
            id: 'subscribers.import.importInProcess.errorMessage',
          }),
        )
        return
      }
      dispatch(resetValidationInfo())
      dispatch(importSubscribersThunk())
    }
  }

  return (
    <ContainedButton
      size="small"
      color={SECONDARY}
      disabled={disabledBtn || isLoading}
      isLoading={isLoading}
      onClick={handleImport}
      className={'h-36 w-full md:w-fit text-14'}
    >
      <FormattedMessage
        id={'subscribers.import.previewTable.ImportBtn.label'}
        values={{ subscribersCount }}
      />
    </ContainedButton>
  )
}

export default memo(ImportButton)
